import type { DropDownResult } from '@myosh/odin-components';
import PersonField from './person-field.component';
import type { PersonFieldProps } from './person-field.component';
import useGetPersonFieldDefaultValue from './use-get-person-field-default-value';
import { useEffect } from 'react';
import type { PersonFieldDependentProps } from '../../../@types/forms';

interface DependentPersonFieldProps extends PersonFieldProps, PersonFieldDependentProps {}

const DependentPersonField = ({
  id,
  control,
  onChange,
  defaultFieldConfiguration,
  value,
  readOnly,
  ...rest
}: DependentPersonFieldProps) => {
  const parentManager = useGetPersonFieldDefaultValue({
    control,
    fieldId: Number(id),
    config: defaultFieldConfiguration,
  });

  useEffect(() => {
    if (!readOnly && parentManager) {
      handleOnChange({ ...parentManager, originalData: { value: parentManager.value, text: parentManager.text } });
    }
  }, [parentManager, readOnly]);

  const handleOnChange = (value?: DropDownResult) => {
    onChange?.(value);
  };

  return (
    <PersonField {...rest} id={id} onChange={handleOnChange} control={control} value={value} readOnly={readOnly} />
  );
};

export default DependentPersonField;
